export abstract class Mensagens {
  static SUCESSO = 'Ação realizada com sucesso';
  static ERRO_INESPERADO = 'Ocorreu um erro inesperado, tente novamente mais tarde';
  static PROCESSANDO_CARGA = 'A carga está sendo processada';
  static PAGINA_NAO_EXISTE = 'A página solicitada não existe';
}